import React from 'react';

interface SvgProps extends React.SVGProps<SVGSVGElement> {
  title?: string;
}

const Options: React.FC<SvgProps> = ({ title, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="151px"
      height="38px"
      viewBox="0 0 151 38"
      aria-labelledby={title ? 'svg-title-debut5' : undefined}
      role="img"
      {...props}
    >
      {title && <title id="svg-title-debut5">{title}</title>}
      {/* Content from debut5.svg */}
      <path
        fill="currentColor"
        stroke="black"
        d="M 33.542 18.344 C 33.542 26.352 27.05 32.844 19.042 32.844 C 11.034 32.844 4.542 26.352 4.542 18.344 C 4.542 10.336 11.034 3.844 19.042 3.844 C 27.05 3.844 33.542 10.336 33.542 18.344 Z M 26.042 23.364 C 26.042 21.701 24.694 20.354 23.032 20.354 C 21.37 20.354 20.022 21.701 20.022 23.364 C 20.022 25.026 21.37 26.374 23.032 26.374 C 24.694 26.374 26.042 25.026 26.042 23.364 Z"
      />
      <path
        fill="currentColor"
        stroke="black"
        d="M 111.172 9.134 L 119.872 15.044 C 120.156 15.243 120.549 15.052 120.58 14.7 C 120.581 14.688 120.582 14.676 120.582 14.664 L 120.582 11.644 C 120.582 11.058 121.056 10.584 121.642 10.584 L 127.982 10.584 C 128.662 10.585 129.189 11.178 129.112 11.854 C 128.372 18.614 128.162 25.82 128.482 33.474 C 128.496 33.774 128.18 33.976 127.913 33.839 C 127.899 33.831 127.885 33.823 127.872 33.814 L 118.092 27.224 C 117.95 27.116 117.745 27.211 117.724 27.394 C 117.722 27.404 117.722 27.414 117.722 27.424 L 117.722 30.964 C 117.722 31.372 117.386 31.704 116.972 31.704 L 110.832 31.704 C 110.231 31.705 109.734 31.239 109.702 30.644 C 109.335 24.23 109.472 17.677 110.112 10.984 C 110.219 9.177 110.572 8.56 111.172 9.134 Z"
      />
      <path
        fill="currentColor"
        stroke="black"
        d="M 107.022 21.283 C 107.033 27.529 101.669 32.602 95.042 32.614 C 88.414 32.625 83.033 27.571 83.022 21.325 C 83.011 15.078 88.375 10.005 95.002 9.994 C 101.63 9.982 107.011 15.037 107.022 21.283 Z M 100.962 25.294 C 100.962 23.841 99.784 22.664 98.332 22.664 C 96.879 22.664 95.702 23.841 95.702 25.294 C 95.702 26.746 96.879 27.924 98.332 27.924 C 99.784 27.924 100.962 26.746 100.962 25.294 Z"
      />
      <path
        fill="currentColor"
        stroke="black"
        d="M 146.152 16.794 C 146.563 17.346 146.346 18.137 145.712 18.404 C 144.525 18.904 143.329 20.917 142.122 24.444 C 140.942 27.884 138.812 30.467 135.732 32.194 C 134.915 32.656 133.881 32.438 133.322 31.684 L 129.652 26.764 C 129.144 26.08 129.302 25.11 130.002 24.624 C 131.489 23.59 132.515 22.427 133.082 21.134 C 135.262 16.144 136.172 13.974 139.792 10.904 C 140.446 10.35 141.434 10.465 141.952 11.154 L 146.152 16.794 Z"
      />
      <path
        fill="currentColor"
        stroke="black"
        d="M 36.572 10.764 C 42.392 10.31 47.062 11.32 50.582 13.794 C 53.972 16.174 54.632 21.294 52.082 24.824 C 50.415 27.13 47.859 28.514 44.412 28.974 C 44.064 29.025 43.823 29.35 43.872 29.704 L 44.082 31.054 C 44.143 31.469 43.822 31.842 43.402 31.844 L 35.952 31.844 C 35.493 31.842 35.107 31.499 35.052 31.044 C 34.239 24.53 34.472 18.014 35.752 11.494 C 35.828 11.093 36.165 10.793 36.572 10.764 Z M 43.312 22.624 L 43.292 26.584 C 43.292 26.645 43.341 26.694 43.402 26.694 L 43.422 26.694 C 44.358 26.699 45.121 25.811 45.122 24.714 L 45.122 24.494 C 45.123 23.404 44.372 22.519 43.442 22.514 L 43.422 22.514 C 43.361 22.514 43.312 22.563 43.312 22.624 Z"
      />
      <path
        fill="currentColor"
        stroke="black"
        d="M 80.992 21.364 C 80.959 24.69 81.199 28.014 81.712 31.334 C 81.755 31.62 81.531 31.877 81.242 31.874 L 73.612 31.874 C 73.25 31.874 72.941 31.611 72.882 31.254 C 72.309 27.774 72.039 24.444 72.072 21.264 C 72.105 18.077 72.445 14.754 73.092 11.294 C 73.156 10.933 73.475 10.673 73.842 10.684 L 81.472 10.854 C 81.758 10.862 81.971 11.122 81.922 11.404 C 81.335 14.71 81.025 18.03 80.992 21.364 Z"
      />
      <path
        fill="currentColor"
        stroke="black"
        d="M 62.692 10.814 C 66.879 10.807 69.399 10.91 70.252 11.124 C 70.618 11.215 70.881 11.531 70.902 11.904 L 71.272 17.784 C 71.301 18.289 70.898 18.715 70.392 18.714 L 67.802 18.714 C 67.524 18.714 67.297 18.931 67.292 19.204 L 67.082 30.974 C 67.073 31.313 66.842 31.608 66.512 31.704 C 66.372 31.744 65.105 31.764 62.712 31.764 C 60.319 31.764 59.052 31.744 58.912 31.704 C 58.585 31.61 58.356 31.32 58.342 30.984 L 58.112 19.214 C 58.106 18.941 57.88 18.724 57.602 18.724 L 55.012 18.724 C 54.506 18.725 54.103 18.299 54.132 17.794 L 54.492 11.914 C 54.512 11.541 54.776 11.225 55.142 11.134 C 55.995 10.92 58.512 10.814 62.692 10.814 Z"
      />
    </svg>
  );
};

export default Options; 